'use client'

import { usePunchoutBackToERPUrl } from '@/feature/punchout/services/punchout.cookies.client'
import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { useNextIsClientHydrated } from '@/lib/next/useNextIsClientHydrated'
import { Button } from '@/ui/buttons/button/Button.client'
import { Icon } from '@/ui/icons/icon/Icon'
import { PreHeaderBanner } from '@/ui/pre-header-banner/PreHeaderBanner'

export function PunchoutBanner() {
  const { t } = useTranslation(['punchoutBanner'])
  const isHydrated = useNextIsClientHydrated()
  const backToERPUrl = usePunchoutBackToERPUrl()

  const handleAction = () => {
    if (backToERPUrl) {
      window.location.href = `/punchout/logout?redirectUrl=${encodeURIComponent(backToERPUrl)}`
    } else {
      window.location.href = '/punchout/logout'
    }
  }

  if (!isHydrated) {
    return null
  }

  return (
    <PreHeaderBanner>
      <Button size="md" variant="link" iconLeft={<Icon.LogOut size="sm" />} onPress={handleAction}>
        {backToERPUrl ? t('punchoutBanner:returnToErp') : t('punchoutBanner:logout')}
      </Button>
    </PreHeaderBanner>
  )
}
